import { render, staticRenderFns } from "./tenth.vue?vue&type=template&id=db2733ac&scoped=true"
import script from "./tenth.vue?vue&type=script&lang=js"
export * from "./tenth.vue?vue&type=script&lang=js"
import style0 from "./tenth.vue?vue&type=style&index=0&id=db2733ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2733ac",
  null
  
)

export default component.exports